module.exports = __webpack_public_path__ + "img/success.4870055f.svg";